import { z } from 'zod';

export const paginationSchema = z.object({
  page: z.number(),
  totalPages: z.number(),
  totalItems: z.number(),
  limit: z.number(),
});

export const responseWithPaginationSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z
    .object({
      data: dataSchema,
      metadata: paginationSchema,
    })
    .strict();
